import React from 'react'
import { Icon, Text, Touchable } from '@/components'
import { APIClient } from '@/services'
import { useIsMobile } from '@/utils'
import { navigation, Theme, variantProvider } from '@/app'
import { LearnSearchModal } from '../modals'

/*
const extraData = {
  tags: { label: 'Job Role', order: 1, multiple: true },
  themes: { label: 'Theme', order: 2, multiple: true },
  formats: { label: 'Format', order: 3, multiple: true },
  sources: { label: 'Source', order: 4, multiple: true },
}

type IFilterLearnProps = {
  modules: APIClient.Learn.UseModulesReturn
}
*/

export function FilterLearn() {
  const isMobile = useIsMobile()

  /*
  const [clearFilters, setClearFilters] = React.useState(false)
  const applyFilter = React.useCallback((key, value) => {
    analytics.track('lesson_filter', { filters: modules.filter })
    modules.setFilter(prev => ({ ...prev, [key]: value }))
  }, [modules])

  const onClear = React.useCallback(() => {
    modules.setFilter(prev => ({ ...prev, author_department: [], categories: [] }))
    setClearFilters(true)
    setTimeout(() => setClearFilters(false))
  }, [modules])

  const filterSources = React.useMemo(() => {
    if (TypeGuards.isNil(modules.filterOptions)) return []
    return Object.entries(modules.filterOptions)
      .map(f => {
        const [key, value] = f

        return {
          ...extraData[key],
          key,
          state: modules.filter[key],
          setter: value => applyFilter(key, value),
          data: value,
        }
      })
      .sort((a, b) => a.order - b.order)
  }, [modules])

  const hasFiltersApplied = React.useMemo(() => filterSources.some((f) => f.state.length > 0), [filterSources])
  */

  const onOpenGlobalSearch = () => {
    const authorized = APIClient.UnknownProfile.maybeOpenRegistrationWall()
    if (!authorized) return

    if (isMobile) {
      return navigation.navigate('Learn.Search')
    } else {
      return LearnSearchModal.open()
    }
  }

  return (
    <Touchable
      style={styles.wrapper}
      onPress={onOpenGlobalSearch}
      debugName="OpenLearnSearch"
    >
      <Icon name="search" style={styles.icon} />
      <Text text={'Search'} variants={['p1', 'color:neutral4', 'regular']} />
    </Touchable>
  )
}

const BREAKPOINT = 'small'
const MAX_WIDTH = 353
const HEIGHT = 40

const styles = variantProvider.createComponentStyle(
  theme => ({
    wrapper: {
      flex: 1,
      width: '100%',
      maxWidth: MAX_WIDTH,
      minWidth: MAX_WIDTH,
      height: 'auto',
      minHeight: HEIGHT,
      maxHeight: HEIGHT,
      borderRadius: theme.borderRadius.rounded,
      ...theme.spacing.paddingHorizontal(2),
      ...theme.border.neutral3(theme.values.borderWidth.small),
      ...theme.presets.justifyStart,
      ...theme.presets.alignCenter,
      ...theme.spacing.gap(1),
      [theme.media.down(BREAKPOINT)]: {
        backgroundColor: theme.colors.neutral1,
        maxWidth: 'auto',
        minWidth: 'auto',
        width: 'auto',
      },
    },
    icon: {
      color: theme.colors.neutral4,
      width: Theme.values.iconSize[2],
      height: Theme.values.iconSize[2],
    },
  }),
  true
)
